<template>
  <v-app-bar
    id="app-bar"
    absolute
    app
    color="transparent"
    flat
    height="75"
  >
    <v-btn
      class="mr-3"
      elevation="1"
      fab
      small
      @click="$vuetify.breakpoint.smAndDown ? setDrawer(!drawer) : $emit('input', !value)"
    >
      <v-icon v-if="value">
        mdi-view-quilt
      </v-icon>

      <v-icon v-else>
        mdi-dots-vertical
      </v-icon>
    </v-btn>

    <v-toolbar-title
      class="hidden-sm-and-down font-weight-light"
      v-text="getName($route.name)"
    />

    <v-spacer />

    <v-menu
      bottom
      left
      min-width="200"
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          class="ml-2"
          min-width="0"
          outlined
          color="secondary"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>

      <v-list
        :tile="false"
        flat
        nav
      >
        <template v-for="(p, i) in profile">
          <v-divider
            v-if="p.divider"
            :key="`divider-${i}`"
            class="mb-2 mt-2"
          />

          <app-bar-item
            v-else-if="p.to && !p.flag"
            :key="`item-${i}`"
            :to="p.to"
          >
            <v-list-item-title v-text="$t(p.title)" />
          </app-bar-item>

          <app-bar-item
            v-else-if="p.flag && p.lang !== $i18n.locale"
            :key="`item-${i}`"
            @click="changeLang(p.lang)"
          >
            <v-list-item-avatar>
              <span :class="'flag-icon flag-icon-squared flag-icon-' + p.flag" />
            </v-list-item-avatar>

            <v-list-item-title
              v-text="$t(p.title)"
            />
          </app-bar-item>
        </template>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
  // Components
  import { VHover, VListItem } from 'vuetify/lib'
  import 'flag-icon-css/css/flag-icon.css'

  // Utilities
  import { mapState, mapMutations } from 'vuex'

  export default {
    name: 'DashboardCoreAppBar',

    components: {
      AppBarItem: {
        render (h) {
          return h(VHover, {
            scopedSlots: {
              default: ({ hover }) => {
                // Permet la propagation du @click pour le changement de langue
                var listeners = {}
                if (this.$listeners && this.$listeners.click) {
                  listeners = {
                    click: this.$listeners.click,
                  }
                }

                return h(VListItem, {
                  attrs: this.$attrs,
                  class: {
                    'black--text': !hover,
                    'white--text secondary elevation-12': hover,
                  },
                  props: {
                    activeClass: '',
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                  on: listeners,
                }, this.$slots.default)
              },
            },
          })
        },
      },
    },

    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      ...mapState(['drawer']),

      // Menu déroulant
      profile: function () {
        return [
          {
            flag: 'fr',
            lang: 'fr',
            title: 'Lang.French',
          },
          {
            flag: 'gb',
            lang: 'en',
            title: 'Lang.English',
          },
          { divider: true },
          {
            title: 'Logout',
            to: '/auth/logout',
          },
        ]
      },
    },

    methods: {
      ...mapMutations({
        setDrawer: 'SET_DRAWER',
      }),

      changeLang: function (lang) {
        this.$i18n.locale = lang
      },

      getName: function (name) {
        return this.$t('Drawer.' + name.trim().split(' ').join(''))
      },
    },
  }
</script>
